namespace FetrapiEnums { 

  export enum MainGroups {
    FetrapiMember = 'FetrapiMember',
    ADCRMember = 'ADCRMember',
    ChIIIMember = 'ChIIIMember',
    FetrapiAdmin = 'FetrapiAdmin',
    SuperUser = 'SuperUser'
  }

  export enum DatasetType {
    Grid = 'Grid',
    ZoI = 'ZoI',
    IntegratedGridData = 'IntegratedGridData',
    KLIMCICCBuffer = 'KLIMCICCBuffer',
    Chapter3Export = 'Chapter3Export',
    ADCRExport = 'ADCRExport'
  }

  export enum DatasetStatusCode {
    Created = 'Created',
    ValidationSucceeded = 'ValidationSucceeded',
    ValidationFailed = 'ValidationFailed',
    MemberApproved = 'MemberApproved',
    MemberRejected = 'MemberRejected',
    MemberConfirmed = 'MemberConfirmed',
    AdminApproved = 'AdminApproved',
    AdminRejected = 'AdminRejected',
    Active = 'Active',
    ConfirmationRequired = 'ConfirmationRequired',
    Archived = 'Archived',
    Failed = 'Failed' 
  }

  export enum ModalType {
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error',
    Fatal = 'Fatal' 
  }
}

  export default FetrapiEnums;
